import { Avatar } from "@material-tailwind/react";

export function AvatarDefault() {
  return <Avatar src="/img/face-2.jpg" alt="avatar" />;
}
